import type { Profile, ProfileSettings } from "../shared/types";
import { defaultProfileSettings } from "../shared/types";

const alertModes = new Set<ProfileSettings["alertMode"]>([
  "voice",
  "soft_chime",
  "off",
]);

/** Normalize both current and pre-alertMode cached settings without surprising legacy users. */
export function normalizeCachedSettings(
  profile: Profile,
  value: unknown,
): ProfileSettings {
  const cached =
    value && typeof value === "object"
      ? (value as Partial<ProfileSettings>)
      : {};
  const alertMode =
    typeof cached.alertMode === "string" &&
    alertModes.has(cached.alertMode as ProfileSettings["alertMode"])
      ? (cached.alertMode as ProfileSettings["alertMode"])
      : typeof cached.chimeEnabled === "boolean"
        ? cached.chimeEnabled
          ? "soft_chime"
          : "off"
        : defaultProfileSettings.alertMode;
  return {
    ...defaultProfileSettings,
    ...cached,
    alertMode,
    chimeEnabled: alertMode !== "off",
    timezone: profile.timezone,
  };
}
